import { render, staticRenderFns } from "./create-edit-notice.vue?vue&type=template&id=3915e68d&scoped=true"
import script from "./create-edit-notice.vue?vue&type=script&lang=js"
export * from "./create-edit-notice.vue?vue&type=script&lang=js"
import style0 from "./create-edit-notice.vue?vue&type=style&index=0&id=3915e68d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3915e68d",
  null
  
)

export default component.exports